module.exports = __webpack_public_path__ + "img/S3F5_new.6c3719f9.jpg";